import { useMediaQuery, useTheme } from '@mui/material';

export const useLaptopLayoutAndUp = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'), {
    noSsr: true,
  });
};
